module.exports = __webpack_public_path__ + "images/memo.png";


//////////////////
// WEBPACK FOOTER
// ./public/images/memo.png
// module id = 2294
// module chunks = 0